import React from 'react'
import type { ComponentProps, MacroComponentData } from '@enonic/react-components'
import QuotePrototype from '/react4xp/components/prototype/Quote'

type QuoteMacroData = {
	quote?: string
	attribution?: string
}

export const QuoteMacro = ({ data }: ComponentProps<MacroComponentData>) => {
	const { quote, attribution } = (data || {}) as QuoteMacroData

	if (!quote && !attribution) {
		return null
	}

	// Inside a RichText field the surrounding block already provides the
	// container, so no `isPart` here.
	return <QuotePrototype quote={quote} attribution={attribution} />
}
